import { render } from "./CartPageGroup.vue?vue&type=template&id=0dcad38c"
import script from "./CartPageGroup.vue?vue&type=script&lang=js"
export * from "./CartPageGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__